import { useEffect, useRef, useState } from "react";
// @ts-ignore
import { H5P as H5PStandalone } from "h5p-standalone";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import { getInteractiveMaterial1 } from "@packages/api/madlenAPI";
import { useTranslation } from "react-i18next";
import LoadingContainer from "@packages/components/Loading";
import { getEnvironment } from "@packages/utils";

const H5PSingleView = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const { id } = useParams();
  // get search params
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();
  console.log(searchParams);

  // Add message listener for WebView communication
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      console.log("Message from WebView:", event.data);

      if (event.data.type === "fromApp") {
        window.top?.postMessage(
          JSON.stringify({
            type: "fromWeb",
            message: "Received your message",
          }),
          "*",
        ); //inside the iframe
        window.ReactNativeWebView?.postMessage(
          JSON.stringify({
            type: "fromWeb",
            message: "Received your message",
          }),
        );
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const loadH5P = async (contentJsonPath: string) => {
    const el = containerRef.current;
    if (!el) return;
    console.log("contentJsonPath: ", contentJsonPath);
    // for local testing
    // contentJsonPath = "/h5p/content/2173373422";
    const options = {
      h5pJsonPath: "/h5p/libraries",
      contentJsonPath,
      frameJs: "/frame.bundle.js",
      frameCss: "/h5p.css",
    };

    await new H5PStandalone(el, options);

    H5P.externalDispatcher.on("xAPI", (event) => {
      console.log("xAPI event: ", event);
      if (isLoading) {
        setIsLoading(false);
      }
      window.top?.postMessage(
        JSON.stringify({
          type: "h5pEvent",
          event: event,
        }),
        "*",
      ); //inside the iframe
      // Send H5P events to mobile app
      window.ReactNativeWebView?.postMessage(
        JSON.stringify({
          type: "h5pEvent",
          event: event,
        }),
      );
    });
  };

  // Enhanced language detection function
  const detectLanguage = (
    pathname: string,
    browserLang: string,
  ): "tr" | "en" | "de" => {
    // Check if path explicitly ends with language code
    if (pathname.endsWith("/tr")) return "tr";
    if (pathname.endsWith("/en")) return "en";
    if (pathname.endsWith("/de")) return "de"; // Added German path detection

    // Check browser language with more comprehensive detection
    const normalizedBrowserLang = browserLang.toLowerCase();

    if (normalizedBrowserLang.startsWith("tr")) return "tr";
    if (normalizedBrowserLang.startsWith("de")) return "de"; // Added German browser detection

    // Default to English
    return "en";
  };

  useEffect(() => {
    const init = async () => {
      if (!id) return;
      const content = await getInteractiveMaterial1(Number(id));
      console.log(content);
      if (!content || !content.contentJsonS3Url) return;
      console.log(content.contentJsonS3Url);
      console.log(window.location.href);

      // Enhanced language detection with German support
      const pathSuffix: "tr" | "en" | "de" | null =
        window.location.href.endsWith("tr")
          ? "tr"
          : window.location.href.endsWith("en")
            ? "en"
            : window.location.href.endsWith("de")
              ? "de" // Added German path detection
              : null;

      console.log("Path suffix:", pathSuffix);

      const browserLang =
        navigator.language || (navigator as any).userLanguage || "en";
      console.log("Browser language:", browserLang);

      // Use enhanced language detection function
      const langSuffix =
        pathSuffix ?? detectLanguage(location.pathname, browserLang);
      console.log("Final language suffix:", langSuffix);

      const contentJsonPath = `${content.contentJsonS3Url}/${langSuffix}${getEnvironment() === "DEV" ? "/dev" : ""}`;
      console.log("Content JSON path:", contentJsonPath);

      await loadH5P(contentJsonPath);
    };

    init();
  }, []);

  return (
    <div className="container max-w-7xl mx-auto px-4 py-8">
      {isLoading && (
        <div className={`flex flex-col justify-center items-center h-full`}>
          <LoadingContainer
            title={t("common.loading")}
            description={t("interactive_material.loadingDescription")}
            themeColor="blue"
            fullHeight={false}
          />
        </div>
      )}
      <div ref={containerRef}></div>
    </div>
  );
};

export default H5PSingleView;
